import { styled } from '@mui/material/styles';
import { Box, Table, TableContainer, TableHead, TableCell, TableRow, Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';

export const StyledContainer = styled(Box)({
  width: '100%',
  backgroundColor: 'transparent',
  padding: '0',
});

export const StyledTableContainer = styled(TableContainer)({
  backgroundColor: 'white',
  boxShadow: 'none',
  borderRadius: '18px 18px 0 0',
  overflow: 'hidden',
});

export const StyledTable = styled(Table)({
  minWidth: 650,
  borderCollapse: 'separate',
  borderSpacing: '0',
});

export const StyledTableHead = styled(TableHead)({
  background: 'white',
  boxShadow: '0 4px 24px 0 rgba(255, 90, 118, 0.10), 0 1.5px 4px 0 rgba(0,0,0,0.04)',
  position: 'relative',
  zIndex: 1,
  borderRadius: '16px 16px 0 0',
  height: '80px',
  width: '100%',
});

export const StyledHeaderCell = styled(TableCell)({
  backgroundColor: 'white',
  fontWeight: 'bold',
  fontSize: '16px',
  padding: '16px',
  color: '#000',
  borderBottom: 'none',
});

export const StyledFirstHeaderCell = styled(StyledHeaderCell)({
  borderTopLeftRadius: '16px',
  fontWeight: 700,
  fontSize: '18px',
  color: '#222',
  background: 'transparent',
  borderBottom: 'none',
  padding: '24px 24px 24px 32px',
});

export const StyledMiddleHeaderCell = styled(StyledHeaderCell)({
  fontWeight: 700,
  fontSize: '18px',
  color: '#222',
  background: 'transparent',
  borderBottom: 'none',
  padding: '24px',
});

export const StyledLastHeaderCell = styled(StyledHeaderCell)({
  borderTopRightRadius: '16px',
  fontWeight: 700,
  fontSize: '18px',
  color: '#222',
  background: 'transparent',
  borderBottom: 'none',
  padding: '24px 32px 24px 24px',
});

export const StyledHeaderBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  });

export const StyledTableRow = styled(TableRow)(({ index }) => ({
  backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
}));

export const StyledModelCell = styled(TableCell)({
  padding: '16px',
  width: '25%',
  borderBottom: 'none',
});

export const StyledModelBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const StyledModelImage = styled('img')({
  width: 32,
  height: 32,
  objectFit: 'contain',
  marginRight: 8,
  borderRadius: '0',
  background: 'none',
  boxShadow: 'none',
});

export const StyledModelName = styled(Typography)({
  fontWeight: 600,
  color: '#222',
  fontFamily: saasModernTheme.fontFamily,
});

export const StyledDescriptionCell = styled(TableCell)({
  padding: '16px',
  width: '50%',
  color: '#555',
  borderBottom: 'none',
  fontFamily: saasModernTheme.fontFamily,
});

export const StyledCostCell = styled(TableCell)({
  padding: '16px',
  width: '25%',
  fontWeight: 500,
  borderBottom: 'none',
  fontFamily: saasModernTheme.fontFamily,
}); 